export const create404Error = () =>
  createError({ statusCode: 404, statusMessage: 'Page Not Found' })

export const show404Error = () =>
  showError({ message: 'Page not found', statusCode: 404 })
